import { useEffect } from 'react'
import * as braze from '@braze/web-sdk'

const useBrazeInit = () => {
  useEffect(() => {
    braze.initialize(import.meta.env.VITE_APP_BRAZE_KEY, {
      baseUrl: import.meta.env.VITE_APP_BRAZE_URL
    })
  }, [])
  return null
}

export default useBrazeInit
